export const COLOR_PALETTES = {
    alpha: {
        cases: {
            bands: { colorNearWhen: '#aaaaaa', colorNearWhat: '#000000' },
            tori: { color: '#aabbd0' },
        },
        macroSteps: { tori: { color: '#55d6ae' } },
        backgroundColor: 'skyblue',
        labels: {
            aboveItemText: 'white',
            aboveItemBackground: 'skyblue',
        },
        activation: {
            active: 'yellow',
            linked: 'black',
        },
        resourceTypes: {
            fill: 'orange',
            label: 'white',
            guide: 'black',
        },
        tools: {
            fill: 'gray',
            label: 'white',
        },
        toolSteps: {
            fill: 'white',
            label: 'white',
            outerRim: '#ffd166',
        },
        connectors: {
            default: 'black',
        },
        roles: {
            input: 'green',
            output: 'red',
            label: 'white',
            guide: 'black',
        },
        workflowStateEntries: {
            input: 'green',
            output: 'red',
            label: 'white',
        },
    },
    // Deep ocean: teal inputs, coral outputs, and warm gold activation.
    beta: {
        cases: {
            bands: { colorNearWhen: '#aaaaaa', colorNearWhat: '#000000' },
            tori: { color: '#7bdff2' },
        },
        macroSteps: { tori: { color: 'pink' } },
        backgroundColor: '#102a43',
        labels: {
            aboveItemText: '#f7fafc',
            aboveItemBackground: '#243b53',
        },
        activation: {
            active: '#ffd166',
            linked: '#7bdff2',
        },
        resourceTypes: {
            fill: '#f4a261',
            label: '#102a43',
            guide: '#9fb3c8',
        },
        tools: {
            fill: '#486581',
            label: '#f7fafc',
        },
        toolSteps: {
            fill: '#d9e2ec',
            label: '#102a43',
            outerRim: '#2a9d8f',
        },
        connectors: {
            default: '#bcccdc',
        },
        roles: {
            input: '#2a9d8f',
            output: '#e76f51',
            label: '#f7fafc',
            guide: '#829ab1',
        },
        workflowStateEntries: {
            input: '#2a9d8f',
            output: '#e76f51',
            label: '#f7fafc',
        },
    },
    // Warm porcelain: forest green and terracotta on a light neutral ground.
    gamma: {
        cases: {
            bands: { colorNearWhen: '#aaaaaa', colorNearWhat: '#000000' },
            tori: { color: '#aabbd0' },
        },
        macroSteps: { tori: { color: '#55d6ae' } },
        backgroundColor: '#f3eee5',
        labels: { aboveItemText: '#342f2a', aboveItemBackground: '#e6dccd' },
        activation: { active: '#b7791f', linked: '#176b81' },
        resourceTypes: { fill: '#d9b984', label: '#342f2a', guide: '#8b7765' },
        tools: { fill: '#b5a58f', label: '#342f2a' },
        toolSteps: { fill: '#e6dccd', label: '#342f2a', outerRim: '#287a67' },
        connectors: { default: '#8b7765' },
        roles: { input: '#287a67', output: '#c65d3b', label: '#342f2a', guide: '#8b7765' },
        workflowStateEntries: { input: '#287a67', output: '#c65d3b', label: '#342f2a' },
    },
    // Midnight violet: mint, rose, and lavender accents.
    delta: {
        cases: {
            bands: { colorNearWhen: '#aaaaaa', colorNearWhat: '#000000' },
            tori: { color: '#aabbd0' },
        },
        macroSteps: { tori: { color: '#55d6ae' } },
        backgroundColor: '#211a33',
        labels: { aboveItemText: '#f4efff', aboveItemBackground: '#352a4b' },
        activation: { active: '#ffe08a', linked: '#8ac8ff' },
        resourceTypes: { fill: '#c4b5fd', label: '#211a33', guide: '#a99bc5' },
        tools: { fill: '#75648f', label: '#f4efff' },
        toolSteps: { fill: '#ddd4ee', label: '#211a33', outerRim: '#68d5b5' },
        connectors: { default: '#a99bc5' },
        roles: { input: '#68d5b5', output: '#ef8fb0', label: '#f4efff', guide: '#a99bc5' },
        workflowStateEntries: { input: '#68d5b5', output: '#ef8fb0', label: '#f4efff' },
    },
    // Nordic mist: blue and raspberry on cool pale grey.
    epsilon: {
        cases: {
            bands: { colorNearWhen: '#aaaaaa', colorNearWhat: '#000000' },
            tori: { color: '#aabbd0' },
        },
        macroSteps: { tori: { color: '#55d6ae' } },
        backgroundColor: '#eaf1f4',
        labels: { aboveItemText: '#253b49', aboveItemBackground: '#d6e3ea' },
        activation: { active: '#a66a00', linked: '#267a65' },
        resourceTypes: { fill: '#94b9c9', label: '#253b49', guide: '#647b89' },
        tools: { fill: '#9baeb9', label: '#253b49' },
        toolSteps: { fill: '#d6e3ea', label: '#253b49', outerRim: '#347fa3' },
        connectors: { default: '#647b89' },
        roles: { input: '#347fa3', output: '#b84a70', label: '#253b49', guide: '#647b89' },
        workflowStateEntries: { input: '#347fa3', output: '#b84a70', label: '#253b49' },
    },
} as const;
